// extracted by mini-css-extract-plugin
export var actionButton = "_8i-1";
export var actionButtons = "_8i-2";
export var actions = "_8i-0";
export var aiUnread = "_8i-10";
export var alignCenter = "_8i-h";
export var backWrapper = "_8i-3";
export var cellContainer = "_8i-4";
export var checkboxContainer = "_8i-5";
export var contentContainer = "_8i-6";
export var contentHeader = "_8i-8";
export var conversationsTableWrapper = "_8i-s";
export var draftReplyBadgeContainer = "_8i-m";
export var dropdownItem = "_8i-b";
export var dropdownItemsContainer = "_8i-a";
export var dropdownTitle = "_8i-c";
export var errorIcon = "_8i-7";
export var filter = "_8i-d";
export var gray = "_8i-i";
export var headerActionButtons = "_8i-e";
export var headerCheckboxContainer = "_8i-f";
export var icon = "_8i-j";
export var menuContainer = "_8i-k";
export var noMoreTicketsIcon = "_8i-12";
export var noMoreTicketsSubText = "_8i-13";
export var oneLine = "_8i-l";
export var optionsButton = "_8i-n";
export var plus = "_8i-o";
export var portalButtonsWrapper = "_8i-g";
export var red = "_8i-p";
export var scrolledTop = "_8i-9";
export var search = "_8i-q";
export var selectedConversationsCount = "_8i-r";
export var spinner = "_8i-t";
export var strong = "_8i-u";
export var summaryCell = "_8i-v";
export var tableContainer = "_8i-11";
export var tagContainer = "_8i-w";
export var threeDots = "_8i-x";
export var twoLines = "_8i-y";
export var unread = "_8i-z";